import Joyride, { type CallBackProps, type Step } from "react-joyride";
import { appJoyrideLocale, appJoyrideStyles } from "./joyride-theme";

type JoyrideCallbackData = {
  status?: string;
  type?: string;
  index?: number;
  action?: string;
};

type AppJoyrideProps = {
  steps: Step[];
  run: boolean;
  onCallback: (data: JoyrideCallbackData) => void;
};

export function AppJoyride({ steps, run, onCallback }: AppJoyrideProps) {
  const handleCallback = (data: CallBackProps) => {
    const { status, type, index, action } = data;
    onCallback({ status, type, index, action });
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={appJoyrideLocale}
      styles={appJoyrideStyles}
    />
  );
}
